/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalFooterButton,
  TypeRampV2,
  sizes,
} from '@smartsheet/lodestar-core';
import { useTranslation } from 'react-i18next';

export type callbackFn = (shouldExit: boolean) => void;

export interface ExitConfirmationModalProps {
  message: string;
  callback: callbackFn;
}

export const ExitConfirmModal = ({
  message,
  callback,
}: ExitConfirmationModalProps) => {
  const { t: translate } = useTranslation();

  const cancelExit = () => callback(false);
  const continueExit = () => callback(true);

  return (
    <Modal
      aria-labelledby="basic-modal-title"
      isOpen={true}
      onCloseRequested={cancelExit}
    >
      <ModalHeader
        title={translate('exitconfirmmodal:title')}
        titleProps={{ id: 'basic-modal-title' }}
        onCloseRequested={cancelExit}
      />
      <ModalBody>
        <TypeRampV2
          system="lodestar"
          variant="bodyText"
          css={css`
            margin-top: ${sizes.medium}px;
          `}
        >
          {message}
        </TypeRampV2>
      </ModalBody>
      <ModalFooter>
        <ModalFooterButton appearance={'secondary'} onClick={cancelExit}>
          Cancel
        </ModalFooterButton>
        <ModalFooterButton onClick={continueExit}>Leave</ModalFooterButton>
      </ModalFooter>
    </Modal>
  );
};
